module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HkLM5J/tc-custom/9783962725761.jpg?1703042048954",
      "alt": "This image is the cover for the book Captains Courageous, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Captains Courageous, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Captains Courageous is an 1897 novel, by Rudyard Kipling, that follows the adventures of fifteen-year-old Harvey Cheyne Jr., the spoiled son of a railroad tycoon, after he is saved from drowning by a Portuguese fisherman in the north Atlantic. The novel originally appeared as a serialisation in McClure's, beginning with the November 1896 edition. In 1900, in his essay “What We Can Expect of the American Boy,” Teddy Roosevelt extolled the book and praised Kipling for describing “in the liveliest way just what a boy should be and do.\"(Excerpt from Wikipedia)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rudyard Kipling\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joseph Rudyard Kipling; (30 December 1865 – 18 January 1936) was an English journalist, short-story writer, poet, and novelist. He was born in India, which inspired much of his work. Kipling's works of fiction include The Jungle Book (1894), Kim (1901), and many short stories, including \"The Man Who Would Be King\" (1888). His poems include \"Mandalay\" (1890), \"Gunga Din\" (1890), \"The Gods of the Copybook Headings\" (1919), \"The White Man's Burden\" (1899), and \"If—\" (1910). He is regarded as a major innovator in the art of the short story; his children's books are classics of children's literature, and one critic described his work as exhibiting \"a versatile and luminous narrative gift\". (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB-ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0